import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { UiModule } from '../../ui/ui.module';
import { GetPricesPipe, FormatPricePipe } from '@pipes/price.pipe';

// Composants existants
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
// import { MenuComponent } from './menu/menu.component';
import { FormNewsComponent } from './form-news/form-news.component';
import { ProductCardComponent } from './product-card/product-card.component';
// import { SearchComponent } from './search/search.component';
import { StepOrderComponent } from './step-order/step-order.component';
import { AddressFormComponent } from './address-form/address-form.component';

// LES NOUVEAUX COMPOSANTS
import { NavHeadComponent } from './nav-head/nav-head.component';
import { GlobalMenuComponent } from './nav-head/global-menu/global-menu.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
// Important : Vérifie que le chemin vers globalMenu est correct ici


@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    // MenuComponent,
    FormNewsComponent,
    ProductCardComponent,
    GetPricesPipe,
    FormatPricePipe,
    // SearchComponent,
    StepOrderComponent,
    AddressFormComponent,

    // ON DÉCLARE SEULEMENT NAVHEAD ET LE GLOBAL MENU
    NavHeadComponent,
    GlobalMenuComponent,
    SearchBarComponent,
  ],
  imports: [
    CommonModule,
    UiModule, // C'est ici que app-search-bar doit se trouver
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    FooterComponent,
    HeaderComponent,
    // MenuComponent,
    FormNewsComponent,
    ProductCardComponent,
    GetPricesPipe,
    FormatPricePipe,
    // SearchComponent,
    StepOrderComponent,
    AddressFormComponent,

    // ON EXPORTE NAVHEAD POUR APP.COMPONENT
    NavHeadComponent,
  ]
})
export class PartialModule { }
